import styles from './collapse.module.scss';
import MaterialCollapse from '@mui/material/Collapse';

/* eslint-disable-next-line */
export interface CollapseProps {
  addEndListener?: any,
  children?: any,
  // classes?: object,
  collapsedSize?: number | string,
  component?: any,
  easing?: { enter?: string, exit?: string } | string,
  in?: boolean,
  orientation?: 'horizontal' | 'vertical',
  sx?: any,
  timeout?: 'auto' | number | {
    appear?: number, enter?: number, exit?: number
  }
}

export function Collapse(props: CollapseProps) {
  return (
    <MaterialCollapse
      in={props.in}
      orientation={props.orientation}
      collapsedSize={props.collapsedSize}
      timeout={props.timeout}
      addEndListener={props.addEndListener}
      easing={props.easing}
      component={props.component}
      sx={props.sx}>
      {props.children}
    </MaterialCollapse>
  );
}

export default Collapse;